var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('BusinessEchartBmap',_vm._b({ref:"map",on:{"map-load":_vm.mapLoad}},'BusinessEchartBmap',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }